import dayjs from 'shared/helpers/dayjs';

export default function formatDateParam(date: dayjs.Dayjs): string {
  return date.format('YYYY-MM-DD');
}
